import { Afiliado } from "../afiliate/afilado";

export class Afiliate {
  static afiliateDesdeObj(obj: object) {
    return new Afiliate(
      `${obj["primerNombre"]} ${obj['segundoNombre']}`,
      obj["tipoDocumento"],
      obj["numeroDocumento"],
      `${obj["primerNombre"]} ${obj['segundoNombre']} ${obj["primerApellido"]} ${obj['segundoApellido']}` ,
      obj["surnames"],
      obj["primerApellido"],
      obj["segundoApellido"],
      obj["fechaNacimiento"],
      obj["genero"],
      obj["estadoCivil"]
    );
  }

  static afiliateDesdeObjAfiliado(obj: Afiliado) {
    return new Afiliate(
      `${obj.primerNombre} ${obj.segundoNombre}`,
      obj.tipoDocumento,
      obj.numeroDocumento,
      `${obj.primerNombre} ${obj.segundoNombre}`.trim(),
      `${obj.primerApellido} ${obj.segundoApellido}`.trim(),
      obj.primerApellido,
      obj.segundoApellido,
      obj.fechaNacimiento,
      obj.genero,
      obj.estadoCivil
    );
  }

  static afiliateDesdeSolicitudCambioEstadoCivil(titular: any) {
    return new Afiliate(
      titular.name,
      titular.docType,
      titular.docNumber,
      titular.names,
      titular.surnames,
      titular.firtSurname,
      titular.lastSurname,
      titular.birthDate,
      titular.gender,
      titular.maritalStatus
    );
  }
  
  constructor(
    public name : string,
    public docType: string,
    public docNumber : string,
    public names : string,
    public surnames : string,
    public firtSurname : string,
    public lastSurname: string,
    public birthDate: string,
    public gender : string,
    public maritalStatus: string
  ) {}
}



